// extracted by mini-css-extract-plugin
export var text = "_37-0";